<template>
  <div class="navbar">
    <div class="goback" @click="routerTo" style="cursor: pointer;">
      <svg-icon icon-class="logo"/>
        <!-- <img src="@/assets/images/portal/logo@52.png" alt="" title="返回首页" @click="routerTo" style="cursor: pointer;"> -->
    </div>
    <!-- <div class="switch" v-if="isSwitch">
      <el-select v-model="switchs" placeholder="请选择" @change="switchModule">
        <el-option
          v-for="(item,index) in option"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="switch" v-if="isSwitch2">
      <el-select v-model="switchs2" placeholder="请选择" @change="switchModule2">
        <el-option
          v-for="(item,index) in option"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->
    <breadcrumb class="breadcrumb-container"/>
    <div class="contact">
      <ul>
        <li><svg-icon icon-class="version"/></li>
        <li>演示版</li>
      </ul>
    </div>
    <div class="right-menu">
      <!-- <template v-if="device!=='mobile'">
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>
      </template> -->
      <el-dropdown class="avatar-container right-menu-item" trigger="hover">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/demo">
            <el-dropdown-item>
              回到首页
            </el-dropdown-item>
          </router-link>
          <router-link to="/personalDemo" v-if="this.tenantSet.tenantInfo == 1">
            <el-dropdown-item>
              <span>个人设置</span>
            </el-dropdown-item>
          </router-link>
          
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Screenfull from '@/components/Screenfull'
import request from '@/utils/request'

export default {
  components: {
    Breadcrumb,
    Screenfull
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'avatar',
      'device',
    ])
  },
  // 跳转首页刷新页面
  inject:['reload'],
  data(){
    return {
      tenantSet:{},
      userName:'',
      isShowLang:false,
      lang:'简体中文',
      isShowE:'',
      position:1,
      opened:true,
      option:[{
          value: '全部',
          label: '全部'
        }, {
          value: '同步',
          label: '同步'
        }, {
          value: '探究',
          label: '探究'
        }],
      switchs:'全部',
      switchs2:'全部'
    }
  },
  created(){
    this.getinfo();
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.isShowE = res.jwtUser.activity
        this.tenantSet = res.tenant
        this.userName = res.jwtUser.username
      })
    },
    // 活动入口
    entrance(){
      // 生产
      window.open("http://192.168.0.133:8001/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
      // 测试
      // window.open("http://221.231.139.161:8011/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
    },
    openExternal(){
      window.open("http://wpa.qq.com/msgrd?v=3&uin=3512883254&site=qq&menu=yes","_blank")
    },
    // 跳转首页刷新页面
    routerTo(){
      window.open("https://zibo.judaoedu.com/");
      // this.$router.push({path:'/'})
      // this.reload();
    },
    toggleSideBar(){
      // this.$store.dispatch('ToggleSideBar')
      this.opened=!this.opened
    },
    logout() {
        localStorage.setItem('language','zh');
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          if(this.tenantSet.id == 30 && this.userName == 'userdemoauto'){
            this.$router.push({path:'/BS'});
          }else{
            this.$router.push({path:'/demonstration'});
          }
        })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.lang-dropdown{
  color: #fff;
}
.lang-dropdown:hover{
  color: #fff;
}
.goback{
  margin-left: 20px;
  height: 100%;
  float: left;
  width: 166px;
  display: none;
}
.switch{
  width: 50px;
  height: 100%;
  float: left;
  line-height: 60px;
}
.switch /deep/ .el-input__suffix{
  display: none;
}
.switch /deep/ .el-input--suffix .el-input__inner{
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  border-color: #2174ff ;
  background-color: rgba(233, 238, 242, .4);
  color: rgb(240, 234, 234);
}
.svg-icon{
  width: 100% !important;
  height: 100% !important;
  padding-top: 2px;
  padding-bottom: 2px;
}
// .goback img{
//   width: 120px;
//   height: 46px;
//   margin-top: 7px;
// }
.goback img{
  // width: 120px;
  // height: 46px;
  margin-top: 4px;
}
  .navbar {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
    height: 60px;
  background:  #2174ff;
    border-bottom: 1px solid #549cff;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 60px;
      float: left;
      padding: 0 10px;
    }
   .app-breadcrumb.el-breadcrumb{
     display: none;
   }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right !important;
      height: 100%;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 60px;
        margin-right: 30px;
        .avatar-wrapper {
          margin-top: 9px;
          position: relative;
          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
.contact{
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  height: 24px;
}
.contact ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.contact ul li{
  color: #fff;
  float:left;
  padding-right:5px;
  font-size: 12px;
  width: 22px;
  height:24px;
  line-height: 24px;
}
.contact ul li:last-of-type{
  padding-right:0;
  padding-left: 0;
  border-right:none;
  width:60px;
  font-size: 14px;
}
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #fff;
    color: #2174ff;
  }
  // .el-select-dropdown{
  //   margin-top: -8px !important;
  //   left: 170px !important;
  // }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color:#fff;
  }
  .el-select-dropdown__item.selected{
    color: #2174ff;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/NavbarDemo.vue